export default __webpack_public_path__ + "static/media/dialog_evaluate_desc_top.464ea3fa.png";